<template>
    <div class="header">
        <div class="container flex">
            <h1
                v-if="!isAuth"
            >
                <router-link
                    to="/"
                >
                    Wojtagram
                </router-link>
            </h1>
            <h1
                v-if="isAuth"
            >
                <router-link
                    to="/main"
                    @click="resetData"
                >
                    Wojtagram
                </router-link>
            </h1>
            <ul class="flex">
                <li>
                    <router-link
                        to="/admin"
                        v-if="isAdmin"
                    >
                        <Settings></Settings>
                    </router-link>
                </li>
                <li
                    v-if="isAuth"
                    @click="logout"
                >
                   <Logout></Logout>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import Logout from '@/assets/img/sign-out-alt-solid.svg'
import Settings from '@/assets/img/cog-solid.svg'

export default {
    components: {
        Logout,
        Settings
    },
    computed: {
        ...mapState(['isAuth']),
        ...mapGetters(['isAdmin'])
    },
    methods: {
        ...mapActions(['message', 'resetState', 'logout']),
        resetData(){
            const payload = {
                page: null,
                year: true
            }

            this.resetState(payload);
        }
    }
}
</script>

